import { render, staticRenderFns } from "./PaymentInfos.vue?vue&type=template&id=787875f6"
import script from "./PaymentInfos.vue?vue&type=script&lang=js"
export * from "./PaymentInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports